// extracted by mini-css-extract-plugin
export var container = "styles-module--container--37585";
export var dark = "styles-module--dark--d5619";
export var review = "styles-module--review--13394";
export var subtitle = "styles-module--subtitle--4e845";
export var title = "styles-module--title--3f27f";